import { render, staticRenderFns } from "./EULA.vue?vue&type=template&id=842f46fa&"
import script from "./EULA.vue?vue&type=script&lang=ts&"
export * from "./EULA.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports